export default __webpack_public_path__ + "static/secondFloor-ed0195ed9c1d259bb215503ef51f422d.png";